/**
 * Generated merged help registry — DO NOT EDIT MANUALLY.
 * Re-run scripts/generate-testid-constants.py to regenerate.
 *
 * Source of truth: every de/help/*.ts file in this directory.
 * Spec: docs/specs/help-system/architecture.md — "HelpOverlay lookup architecture".
 */

// CPD-OFF

import type { HelpEntry, HelpFile } from '../../types/help'

import { accessAnalyticsDashboardHelp } from './accessAnalyticsDashboard'
import { accessGovernanceHelp } from './accessGovernance'
import { accessProfileCreateHelp } from './accessProfileCreate'
import { accessProfileDetailHelp } from './accessProfileDetail'
import { accessProfileEditHelp } from './accessProfileEdit'
import { accessProfileFormHelp } from './accessProfileForm'
import { accessProfilesHelp } from './accessProfiles'
import { accessRequestDetailHelp } from './accessRequestDetail'
import { accessRequestWizardHelp } from './accessRequestWizard'
import { accessRequestsHelp } from './accessRequests'
import { accessSnapshotViewHelp } from './accessSnapshotView'
import { accessTimelineHelp } from './accessTimeline'
import { accountDetailHelp } from './accountDetail'
import { accountStatusEventsTimelineHelp } from './accountStatusEventsTimeline'
import { accountStatusHeaderHelp } from './accountStatusHeader'
import { accountsHelp } from './accounts'
import { adminHelp } from './admin'
import { adminNotificationLogHelp } from './adminNotificationLog'
import { announcerHelp } from './announcer'
import { appHelp } from './app'
import { approvalChainHelp } from './approvalChain'
import { approvalPoliciesHelp } from './approvalPolicies'
import { approvalPolicyCreateHelp } from './approvalPolicyCreate'
import { approvalPolicyDetailHelp } from './approvalPolicyDetail'
import { approvalPolicyEditHelp } from './approvalPolicyEdit'
import { approvalPolicyFormHelp } from './approvalPolicyForm'
import { assignRoleDialogHelp } from './assignRoleDialog'
import { assignmentDecisionsHelp } from './assignmentDecisions'
import { attributeAuthorityBadgeHelp } from './attributeAuthorityBadge'
import { attributeDefinitionsHelp } from './attributeDefinitions'
import { attributeFormRendererHelp } from './attributeFormRenderer'
import { attributeMappingEditorHelp } from './attributeMappingEditor'
import { attributeValueInputHelp } from './attributeValueInput'
import { authLoopPageHelp } from './authLoopPage'
import { authorityViolationsSectionHelp } from './authorityViolationsSection'
import { autoAssignRuleDetailHelp } from './autoAssignRuleDetail'
import { autoAssignRuleExecutionsHelp } from './autoAssignRuleExecutions'
import { autoAssignRuleRequestCreateWizardHelp } from './autoAssignRuleRequestCreateWizard'
import { autoAssignRuleRequestDetailHelp } from './autoAssignRuleRequestDetail'
import { autoAssignRuleRequestEditHelp } from './autoAssignRuleRequestEdit'
import { autoAssignRuleRequestsHelp } from './autoAssignRuleRequests'
import { autoAssignRulesHelp } from './autoAssignRules'
import { backgroundJobsDashboardHelp } from './backgroundJobsDashboard'
import { beneficiaryMultiSelectHelp } from './beneficiaryMultiSelect'
import { brandThemeToggleHelp } from './brandThemeToggle'
import { buttonSpinnerHelp } from './buttonSpinner'
import { calendarHelp } from './calendar'
import { campaignFormFieldsHelp } from './campaignFormFields'
import { cardSectionHelp } from './cardSection'
import { categoryPickerDialogHelp } from './categoryPickerDialog'
import { certificationCampaignDetailHelp } from './certificationCampaignDetail'
import { certificationCampaignsHelp } from './certificationCampaigns'
import { certificationDashboardHelp } from './certificationDashboard'
import { certificationPoliciesHelp } from './certificationPolicies'
import { certificationPolicyDetailHelp } from './certificationPolicyDetail'
import { certificationPolicyWizardHelp } from './certificationPolicyWizard'
import { certificationReviewsHelp } from './certificationReviews'
import { clusterNodesHelp } from './clusterNodes'
import { colorPickerHelp } from './colorPicker'
import { comboboxHelp } from './combobox'
import { compareGrantsHelp } from './compareGrants'
import { conditionsEditorHelp } from './conditionsEditor'
import { connectorAttributesTabHelp } from './connectorAttributesTab'
import { connectorConfigFormHelp } from './connectorConfigForm'
import { connectorLogViewHelp } from './connectorLogView'
import { connectorOverviewCardHelp } from './connectorOverviewCard'
import { connectorTestDialogHelp } from './connectorTestDialog'
import { connectorsHelp } from './connectors'
import { createFunctionGroupHelp } from './createFunctionGroup'
import { createInboundConnectorDialogHelp } from './createInboundConnectorDialog'
import { createPartyHelp } from './createParty'
import { createResourceHelp } from './createResource'
import { createTargetSystemHelp } from './createTargetSystem'
import { dashboardHelp } from './dashboard'
import { databaseConfigCardHelp } from './databaseConfigCard'
import { definitionImpactConfirmDialogHelp } from './definitionImpactConfirmDialog'
import { delegationFormDialogHelp } from './delegationFormDialog'
import { delegationsHelp } from './delegations'
import { designerToolbarHelp } from './designerToolbar'
import { detectionHistoryCardHelp } from './detectionHistoryCard'
import { dragHandleHelp } from './dragHandle'
import { effectiveAccessByIdentityHelp } from './effectiveAccessByIdentity'
import { effectiveAccessBySystemHelp } from './effectiveAccessBySystem'
import { emailConfigCardHelp } from './emailConfigCard'
import { emptyStateHelp } from './emptyState'
import { enforcementObjectDetailHelp } from './enforcementObjectDetail'
import { enforcementObjectsHelp } from './enforcementObjects'
import { errorBannerHelp } from './errorBanner'
import { errorLogDetailHelp } from './errorLogDetail'
import { errorLogsHelp } from './errorLogs'
import { escalationThresholdsHelp } from './escalationThresholds'
import { executionDetailHelp } from './executionDetail'
import { executionLogViewerHelp } from './executionLogViewer'
import { existingPartySelectorHelp } from './existingPartySelector'
import { expressionEditorHelp } from './expressionEditor'
import { fieldCardHelp } from './fieldCard'
import { fieldPaletteHelp } from './fieldPalette'
import { fieldPropertiesHelp } from './fieldProperties'
import { filterPanelHelp } from './filterPanel'
import { footerHelp } from './footer'
import { formLayoutDesignerPageHelp } from './formLayoutDesignerPage'
import { formLayoutListPageHelp } from './formLayoutListPage'
import { functionGroupDetailHelp } from './functionGroupDetail'
import { functionGroupRequestDetailHelp } from './functionGroupRequestDetail'
import { functionGroupRequestWizardHelp } from './functionGroupRequestWizard'
import { functionGroupRequestsHelp } from './functionGroupRequests'
import { functionGroupsHelp } from './functionGroups'
import { headerHelp } from './header'
import { helpToggleButtonHelp } from './helpToggleButton'
import { iconPickerHelp } from './iconPicker'
import { identitiesHelp } from './identities'
import { identityDetailHelp } from './identityDetail'
import { identityGrantsDetailHelp } from './identityGrantsDetail'
import { identityLifecycleHeaderHelp } from './identityLifecycleHeader'
import { identityLifecycleTimelineHelp } from './identityLifecycleTimeline'
import { identityManagementHelp } from './identityManagement'
import { identityManagerPickerHelp } from './identityManagerPicker'
import { identityManagerSectionHelp } from './identityManagerSection'
import { identitySelectorHelp } from './identitySelector'
import { identitySnapshotViewHelp } from './identitySnapshotView'
import { identityStepHelp } from './identityStep'
import { impactAnalysisDialogHelp } from './impactAnalysisDialog'
import { impersonationBannerHelp } from './impersonationBanner'
import { inboundConnectorConfigLayoutHelp } from './inboundConnectorConfigLayout'
import { inboundConnectorDetailHelp } from './inboundConnectorDetail'
import { inboundConnectorsHelp } from './inboundConnectors'
import { inlineAttributeEditorHelp } from './inlineAttributeEditor'
import { jobBreadcrumbsHelp } from './jobBreadcrumbs'
import { jobBuilderPageHelp } from './jobBuilderPage'
import { jobDetailHelp } from './jobDetail'
import { jobExecutionsHelp } from './jobExecutions'
import { jobsHelp } from './jobs'
import { k8sConfigCardHelp } from './k8sConfigCard'
import { languageSwitcherHelp } from './languageSwitcher'
import { layoutActiveIndicatorHelp } from './layoutActiveIndicator'
import { layoutCanvasHelp } from './layoutCanvas'
import { ldapConfigCardHelp } from './ldapConfigCard'
import { ldapProvisioningConfigEditorHelp } from './ldapProvisioningConfigEditor'
import { lifecycleEventsHelp } from './lifecycleEvents'
import { llmPromptDetailHelp } from './llmPromptDetail'
import { llmPromptsHelp } from './llmPrompts'
import { loadingStateHelp } from './loadingState'
import { logoHelp } from './logo'
import { mintApiKeyDialogHelp } from './mintApiKeyDialog'
import { mockLoginHelp } from './mockLogin'
import { myHelp } from './my'
import { myAccessHelp } from './myAccess'
import { myApprovalsHelp } from './myApprovals'
import { myDashboardHelp } from './myDashboard'
import { myDelegationsHelp } from './myDelegations'
import { myRequestsHelp } from './myRequests'
import { myResponsibilitiesHelp } from './myResponsibilities'
import { newRequestButtonsHelp } from './newRequestButtons'
import { notFoundHelp } from './notFound'
import { notificationBellHelp } from './notificationBell'
import { notificationDetailHelp } from './notificationDetail'
import { notificationHistoryHelp } from './notificationHistory'
import { notificationTemplateDetailHelp } from './notificationTemplateDetail'
import { notificationTemplatesHelp } from './notificationTemplates'
import { onboardingWizardHelp } from './onboardingWizard'
import { organizationStepHelp } from './organizationStep'
import { outboundConnectorDetailHelp } from './outboundConnectorDetail'
import { outboundConnectorsHelp } from './outboundConnectors'
import { overviewSubPageHelp } from './overviewSubPage'
import { ownersPickerHelp } from './ownersPicker'
import { ownersSectionHelp } from './ownersSection'
import { pageBackButtonHelp } from './pageBackButton'
import { pageLayoutHelp } from './pageLayout'
import { pageSpinnerHelp } from './pageSpinner'
import { paginationHelp } from './pagination'
import { parameterEditorHelp } from './parameterEditor'
import { parameterFormHelp } from './parameterForm'
import { partiesHelp } from './parties'
import { partyDetailHelp } from './partyDetail'
import { patternSuggestDialogHelp } from './patternSuggestDialog'
import { peerRecommendationListHelp } from './peerRecommendationList'
import { previewPaneHelp } from './previewPane'
import { previewResultDialogHelp } from './previewResultDialog'
import { profileHelp } from './profile'
import { progressBarHelp } from './progressBar'
import { propertyPanelHelp } from './propertyPanel'
import { provisioningHelp } from './provisioning'
import { provisioningDashboardHelp } from './provisioningDashboard'
import { provisioningHistoryHelp } from './provisioningHistory'
import { provisioningTaskDetailHelp } from './provisioningTaskDetail'
import { provisioningTasksHelp } from './provisioningTasks'
import { provisioningTasksSubPageHelp } from './provisioningTasksSubPage'
import { recentNotificationsHelp } from './recentNotifications'
import { registryHelpIconPortalHelp } from './registryHelpIconPortal'
import { rehireReviewHelp } from './rehireReview'
import { rehireReviewDetailHelp } from './rehireReviewDetail'
import { relationshipSchemaHelp } from './relationshipSchema'
import { removeRoleDialogHelp } from './removeRoleDialog'
import { reportCategoriesPageHelp } from './reportCategoriesPage'
import { reportDefinitionDetailHelp } from './reportDefinitionDetail'
import { reportDefinitionEditHelp } from './reportDefinitionEdit'
import { requestDetailHelp } from './requestDetail'
import { requestInspectorHelp } from './requestInspector'
import { requestInspectorDetailHelp } from './requestInspectorDetail'
import { resourceDetailHelp } from './resourceDetail'
import { resourcesHelp } from './resources'
import { responseFiltersEditorHelp } from './responseFiltersEditor'
import { restConfigCardHelp } from './restConfigCard'
import { restConfigEditDialogHelp } from './restConfigEditDialog'
import { restrictionRuleDetailHelp } from './restrictionRuleDetail'
import { restrictionRuleDetectionsHelp } from './restrictionRuleDetections'
import { restrictionRuleRequestCreateWizardHelp } from './restrictionRuleRequestCreateWizard'
import { restrictionRuleRequestDetailHelp } from './restrictionRuleRequestDetail'
import { restrictionRuleRequestEditHelp } from './restrictionRuleRequestEdit'
import { restrictionRuleRequestsHelp } from './restrictionRuleRequests'
import { restrictionRuleViolationsHelp } from './restrictionRuleViolations'
import { restrictionRuleViolationsDashboardHelp } from './restrictionRuleViolationsDashboard'
import { restrictionRulesHelp } from './restrictionRules'
import { resultTableHelp } from './resultTable'
import { reviewInfoCardHelp } from './reviewInfoCard'
import { reviewStepHelp } from './reviewStep'
import { revokeApiKeyDialogHelp } from './revokeApiKeyDialog'
import { roleAssignmentsHelp } from './roleAssignments'
import { roleDetailHelp } from './roleDetail'
import { rolesHelp } from './roles'
import { sapAbapConfigCardHelp } from './sapAbapConfigCard'
import { sapAbapOutboundConfigCardHelp } from './sapAbapOutboundConfigCard'
import { sapAbapOutboundConfigEditDialogHelp } from './sapAbapOutboundConfigEditDialog'
import { sapHcmInboundConfigCardHelp } from './sapHcmInboundConfigCard'
import { sapHcmInboundConfigEditDialogHelp } from './sapHcmInboundConfigEditDialog'
import { sapSfEcInboundConfigCardHelp } from './sapSfEcInboundConfigCard'
import { sapSfEcInboundConfigEditDialogHelp } from './sapSfEcInboundConfigEditDialog'
import { schemaHelp } from './schema'
import { schemaPoliciesHelp } from './schemaPolicies'
import { schemaPolicyEditHelp } from './schemaPolicyEdit'
import { schemaViolationsHelp } from './schemaViolations'
import { scimConfigCardHelp } from './scimConfigCard'
import { scopePreviewPanelHelp } from './scopePreviewPanel'
import { scriptConfigCardHelp } from './scriptConfigCard'
import { scriptEditorCoreHelp } from './scriptEditorCore'
import { scriptEditorPageHelp } from './scriptEditorPage'
import { scriptExecuteLogPageHelp } from './scriptExecuteLogPage'
import { scriptInboundConfigCardHelp } from './scriptInboundConfigCard'
import { scriptSqlDialogHelp } from './scriptSqlDialog'
import { sectionCardHelp } from './sectionCard'
import { sectionPageHeaderHelp } from './sectionPageHeader'
import { sectionPropertiesHelp } from './sectionProperties'
import { serverUnavailableOverlayHelp } from './serverUnavailableOverlay'
import { serviceAccountDetailHelp } from './serviceAccountDetail'
import { serviceAccountsHelp } from './serviceAccounts'
import { severityBadgeHelp } from './severityBadge'
import { sidebarNavHelp } from './sidebarNav'
import { skipToContentLinkHelp } from './skipToContentLink'
import { sourcesCardHelp } from './sourcesCard'
import { spanDetailSheetHelp } from './spanDetailSheet'
import { spanWaterfallHelp } from './spanWaterfall'
import { sqlAssistPanelHelp } from './sqlAssistPanel'
import { sqlEditorHelp } from './sqlEditor'
import { sqlEditorDialogHelp } from './sqlEditorDialog'
import { syncRunsTabHelp } from './syncRunsTab'
import { systemDetailHelp } from './systemDetail'
import { systemGrantsDetailHelp } from './systemGrantsDetail'
import { systemsHelp } from './systems'
import { tableEmptyStateHelp } from './tableEmptyState'
import { tagInputHelp } from './tagInput'
import { targetSystemsResourcesHelp } from './targetSystemsResources'
import { testDataGeneratorHelp } from './testDataGenerator'
import { testResultsPanelHelp } from './testResultsPanel'
import { themeToggleHelp } from './themeToggle'
import { timeSwitchHelp } from './timeSwitch'
import { toasterHelp } from './toaster'
import { triggerFullEvaluationButtonHelp } from './triggerFullEvaluationButton'
import { typeDetailHelp } from './typeDetail'
import { typeScopeFilterHelp } from './typeScopeFilter'
import { typeScopeSelectorHelp } from './typeScopeSelector'
import { typeValueDetailHelp } from './typeValueDetail'
import { typeValuesViewHelp } from './typeValuesView'
import { typesHelp } from './types'
import { unifiedSearchBarHelp } from './unifiedSearchBar'
import { unifiedSearchBarDemoHelp } from './unifiedSearchBarDemo'
import { valueListDetailHelp } from './valueListDetail'
import { valueListsHelp } from './valueLists'
import { versionHistoryCardHelp } from './versionHistoryCard'
import { wizardStepBasicsHelp } from './wizardStepBasics'
import { wizardStepLaunchHelp } from './wizardStepLaunch'
import { wizardStepReviewSettingsHelp } from './wizardStepReviewSettings'
import { wizardStepScopeHelp } from './wizardStepScope'
import { workflowTimelineCardHelp } from './workflowTimelineCard'

export interface HelpRegistryEntry {
  readonly text: string
  readonly anchor?: string
  readonly label: string
  readonly fileIndex: number
}

type AnyHelpFile = HelpFile

function humaniseTestId(testid: string): string {
  return 'Help for ' + testid
    .split('-')
    .filter(Boolean)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
}

const docPages: string[] = []

const prefixEntries: Array<readonly [string, HelpRegistryEntry]> = []

function mergeHelp(
  registry: Record<string, HelpRegistryEntry>,
  help: AnyHelpFile,
): void {
  const fileIndex = docPages.length
  docPages.push(help.docPage ?? '')
  const texts = help.texts as Readonly<Record<string, HelpEntry | undefined>>
  for (const testid of Object.keys(texts)) {
    const entry = texts[testid]
    if (entry === undefined || entry === null) continue
    const label = humaniseTestId(testid)
    const registryEntry: HelpRegistryEntry = typeof entry === 'string'
      ? { text: entry, label, fileIndex }
      : { text: entry.text, anchor: entry.anchor, label, fileIndex }
    if (testid.endsWith('-')) {
      prefixEntries.push([testid, registryEntry])
    } else {
      registry[testid] = registryEntry
    }
  }
}

const registry: Record<string, HelpRegistryEntry> = {}
mergeHelp(registry, accessAnalyticsDashboardHelp as AnyHelpFile)
mergeHelp(registry, accessGovernanceHelp as AnyHelpFile)
mergeHelp(registry, accessProfileCreateHelp as AnyHelpFile)
mergeHelp(registry, accessProfileDetailHelp as AnyHelpFile)
mergeHelp(registry, accessProfileEditHelp as AnyHelpFile)
mergeHelp(registry, accessProfileFormHelp as AnyHelpFile)
mergeHelp(registry, accessProfilesHelp as AnyHelpFile)
mergeHelp(registry, accessRequestDetailHelp as AnyHelpFile)
mergeHelp(registry, accessRequestWizardHelp as AnyHelpFile)
mergeHelp(registry, accessRequestsHelp as AnyHelpFile)
mergeHelp(registry, accessSnapshotViewHelp as AnyHelpFile)
mergeHelp(registry, accessTimelineHelp as AnyHelpFile)
mergeHelp(registry, accountDetailHelp as AnyHelpFile)
mergeHelp(registry, accountStatusEventsTimelineHelp as AnyHelpFile)
mergeHelp(registry, accountStatusHeaderHelp as AnyHelpFile)
mergeHelp(registry, accountsHelp as AnyHelpFile)
mergeHelp(registry, adminHelp as AnyHelpFile)
mergeHelp(registry, adminNotificationLogHelp as AnyHelpFile)
mergeHelp(registry, announcerHelp as AnyHelpFile)
mergeHelp(registry, appHelp as AnyHelpFile)
mergeHelp(registry, approvalChainHelp as AnyHelpFile)
mergeHelp(registry, approvalPoliciesHelp as AnyHelpFile)
mergeHelp(registry, approvalPolicyCreateHelp as AnyHelpFile)
mergeHelp(registry, approvalPolicyDetailHelp as AnyHelpFile)
mergeHelp(registry, approvalPolicyEditHelp as AnyHelpFile)
mergeHelp(registry, approvalPolicyFormHelp as AnyHelpFile)
mergeHelp(registry, assignRoleDialogHelp as AnyHelpFile)
mergeHelp(registry, assignmentDecisionsHelp as AnyHelpFile)
mergeHelp(registry, attributeAuthorityBadgeHelp as AnyHelpFile)
mergeHelp(registry, attributeDefinitionsHelp as AnyHelpFile)
mergeHelp(registry, attributeFormRendererHelp as AnyHelpFile)
mergeHelp(registry, attributeMappingEditorHelp as AnyHelpFile)
mergeHelp(registry, attributeValueInputHelp as AnyHelpFile)
mergeHelp(registry, authLoopPageHelp as AnyHelpFile)
mergeHelp(registry, authorityViolationsSectionHelp as AnyHelpFile)
mergeHelp(registry, autoAssignRuleDetailHelp as AnyHelpFile)
mergeHelp(registry, autoAssignRuleExecutionsHelp as AnyHelpFile)
mergeHelp(registry, autoAssignRuleRequestCreateWizardHelp as AnyHelpFile)
mergeHelp(registry, autoAssignRuleRequestDetailHelp as AnyHelpFile)
mergeHelp(registry, autoAssignRuleRequestEditHelp as AnyHelpFile)
mergeHelp(registry, autoAssignRuleRequestsHelp as AnyHelpFile)
mergeHelp(registry, autoAssignRulesHelp as AnyHelpFile)
mergeHelp(registry, backgroundJobsDashboardHelp as AnyHelpFile)
mergeHelp(registry, beneficiaryMultiSelectHelp as AnyHelpFile)
mergeHelp(registry, brandThemeToggleHelp as AnyHelpFile)
mergeHelp(registry, buttonSpinnerHelp as AnyHelpFile)
mergeHelp(registry, calendarHelp as AnyHelpFile)
mergeHelp(registry, campaignFormFieldsHelp as AnyHelpFile)
mergeHelp(registry, cardSectionHelp as AnyHelpFile)
mergeHelp(registry, categoryPickerDialogHelp as AnyHelpFile)
mergeHelp(registry, certificationCampaignDetailHelp as AnyHelpFile)
mergeHelp(registry, certificationCampaignsHelp as AnyHelpFile)
mergeHelp(registry, certificationDashboardHelp as AnyHelpFile)
mergeHelp(registry, certificationPoliciesHelp as AnyHelpFile)
mergeHelp(registry, certificationPolicyDetailHelp as AnyHelpFile)
mergeHelp(registry, certificationPolicyWizardHelp as AnyHelpFile)
mergeHelp(registry, certificationReviewsHelp as AnyHelpFile)
mergeHelp(registry, clusterNodesHelp as AnyHelpFile)
mergeHelp(registry, colorPickerHelp as AnyHelpFile)
mergeHelp(registry, comboboxHelp as AnyHelpFile)
mergeHelp(registry, compareGrantsHelp as AnyHelpFile)
mergeHelp(registry, conditionsEditorHelp as AnyHelpFile)
mergeHelp(registry, connectorAttributesTabHelp as AnyHelpFile)
mergeHelp(registry, connectorConfigFormHelp as AnyHelpFile)
mergeHelp(registry, connectorLogViewHelp as AnyHelpFile)
mergeHelp(registry, connectorOverviewCardHelp as AnyHelpFile)
mergeHelp(registry, connectorTestDialogHelp as AnyHelpFile)
mergeHelp(registry, connectorsHelp as AnyHelpFile)
mergeHelp(registry, createFunctionGroupHelp as AnyHelpFile)
mergeHelp(registry, createInboundConnectorDialogHelp as AnyHelpFile)
mergeHelp(registry, createPartyHelp as AnyHelpFile)
mergeHelp(registry, createResourceHelp as AnyHelpFile)
mergeHelp(registry, createTargetSystemHelp as AnyHelpFile)
mergeHelp(registry, dashboardHelp as AnyHelpFile)
mergeHelp(registry, databaseConfigCardHelp as AnyHelpFile)
mergeHelp(registry, definitionImpactConfirmDialogHelp as AnyHelpFile)
mergeHelp(registry, delegationFormDialogHelp as AnyHelpFile)
mergeHelp(registry, delegationsHelp as AnyHelpFile)
mergeHelp(registry, designerToolbarHelp as AnyHelpFile)
mergeHelp(registry, detectionHistoryCardHelp as AnyHelpFile)
mergeHelp(registry, dragHandleHelp as AnyHelpFile)
mergeHelp(registry, effectiveAccessByIdentityHelp as AnyHelpFile)
mergeHelp(registry, effectiveAccessBySystemHelp as AnyHelpFile)
mergeHelp(registry, emailConfigCardHelp as AnyHelpFile)
mergeHelp(registry, emptyStateHelp as AnyHelpFile)
mergeHelp(registry, enforcementObjectDetailHelp as AnyHelpFile)
mergeHelp(registry, enforcementObjectsHelp as AnyHelpFile)
mergeHelp(registry, errorBannerHelp as AnyHelpFile)
mergeHelp(registry, errorLogDetailHelp as AnyHelpFile)
mergeHelp(registry, errorLogsHelp as AnyHelpFile)
mergeHelp(registry, escalationThresholdsHelp as AnyHelpFile)
mergeHelp(registry, executionDetailHelp as AnyHelpFile)
mergeHelp(registry, executionLogViewerHelp as AnyHelpFile)
mergeHelp(registry, existingPartySelectorHelp as AnyHelpFile)
mergeHelp(registry, expressionEditorHelp as AnyHelpFile)
mergeHelp(registry, fieldCardHelp as AnyHelpFile)
mergeHelp(registry, fieldPaletteHelp as AnyHelpFile)
mergeHelp(registry, fieldPropertiesHelp as AnyHelpFile)
mergeHelp(registry, filterPanelHelp as AnyHelpFile)
mergeHelp(registry, footerHelp as AnyHelpFile)
mergeHelp(registry, formLayoutDesignerPageHelp as AnyHelpFile)
mergeHelp(registry, formLayoutListPageHelp as AnyHelpFile)
mergeHelp(registry, functionGroupDetailHelp as AnyHelpFile)
mergeHelp(registry, functionGroupRequestDetailHelp as AnyHelpFile)
mergeHelp(registry, functionGroupRequestWizardHelp as AnyHelpFile)
mergeHelp(registry, functionGroupRequestsHelp as AnyHelpFile)
mergeHelp(registry, functionGroupsHelp as AnyHelpFile)
mergeHelp(registry, headerHelp as AnyHelpFile)
mergeHelp(registry, helpToggleButtonHelp as AnyHelpFile)
mergeHelp(registry, iconPickerHelp as AnyHelpFile)
mergeHelp(registry, identitiesHelp as AnyHelpFile)
mergeHelp(registry, identityDetailHelp as AnyHelpFile)
mergeHelp(registry, identityGrantsDetailHelp as AnyHelpFile)
mergeHelp(registry, identityLifecycleHeaderHelp as AnyHelpFile)
mergeHelp(registry, identityLifecycleTimelineHelp as AnyHelpFile)
mergeHelp(registry, identityManagementHelp as AnyHelpFile)
mergeHelp(registry, identityManagerPickerHelp as AnyHelpFile)
mergeHelp(registry, identityManagerSectionHelp as AnyHelpFile)
mergeHelp(registry, identitySelectorHelp as AnyHelpFile)
mergeHelp(registry, identitySnapshotViewHelp as AnyHelpFile)
mergeHelp(registry, identityStepHelp as AnyHelpFile)
mergeHelp(registry, impactAnalysisDialogHelp as AnyHelpFile)
mergeHelp(registry, impersonationBannerHelp as AnyHelpFile)
mergeHelp(registry, inboundConnectorConfigLayoutHelp as AnyHelpFile)
mergeHelp(registry, inboundConnectorDetailHelp as AnyHelpFile)
mergeHelp(registry, inboundConnectorsHelp as AnyHelpFile)
mergeHelp(registry, inlineAttributeEditorHelp as AnyHelpFile)
mergeHelp(registry, jobBreadcrumbsHelp as AnyHelpFile)
mergeHelp(registry, jobBuilderPageHelp as AnyHelpFile)
mergeHelp(registry, jobDetailHelp as AnyHelpFile)
mergeHelp(registry, jobExecutionsHelp as AnyHelpFile)
mergeHelp(registry, jobsHelp as AnyHelpFile)
mergeHelp(registry, k8sConfigCardHelp as AnyHelpFile)
mergeHelp(registry, languageSwitcherHelp as AnyHelpFile)
mergeHelp(registry, layoutActiveIndicatorHelp as AnyHelpFile)
mergeHelp(registry, layoutCanvasHelp as AnyHelpFile)
mergeHelp(registry, ldapConfigCardHelp as AnyHelpFile)
mergeHelp(registry, ldapProvisioningConfigEditorHelp as AnyHelpFile)
mergeHelp(registry, lifecycleEventsHelp as AnyHelpFile)
mergeHelp(registry, llmPromptDetailHelp as AnyHelpFile)
mergeHelp(registry, llmPromptsHelp as AnyHelpFile)
mergeHelp(registry, loadingStateHelp as AnyHelpFile)
mergeHelp(registry, logoHelp as AnyHelpFile)
mergeHelp(registry, mintApiKeyDialogHelp as AnyHelpFile)
mergeHelp(registry, mockLoginHelp as AnyHelpFile)
mergeHelp(registry, myHelp as AnyHelpFile)
mergeHelp(registry, myAccessHelp as AnyHelpFile)
mergeHelp(registry, myApprovalsHelp as AnyHelpFile)
mergeHelp(registry, myDashboardHelp as AnyHelpFile)
mergeHelp(registry, myDelegationsHelp as AnyHelpFile)
mergeHelp(registry, myRequestsHelp as AnyHelpFile)
mergeHelp(registry, myResponsibilitiesHelp as AnyHelpFile)
mergeHelp(registry, newRequestButtonsHelp as AnyHelpFile)
mergeHelp(registry, notFoundHelp as AnyHelpFile)
mergeHelp(registry, notificationBellHelp as AnyHelpFile)
mergeHelp(registry, notificationDetailHelp as AnyHelpFile)
mergeHelp(registry, notificationHistoryHelp as AnyHelpFile)
mergeHelp(registry, notificationTemplateDetailHelp as AnyHelpFile)
mergeHelp(registry, notificationTemplatesHelp as AnyHelpFile)
mergeHelp(registry, onboardingWizardHelp as AnyHelpFile)
mergeHelp(registry, organizationStepHelp as AnyHelpFile)
mergeHelp(registry, outboundConnectorDetailHelp as AnyHelpFile)
mergeHelp(registry, outboundConnectorsHelp as AnyHelpFile)
mergeHelp(registry, overviewSubPageHelp as AnyHelpFile)
mergeHelp(registry, ownersPickerHelp as AnyHelpFile)
mergeHelp(registry, ownersSectionHelp as AnyHelpFile)
mergeHelp(registry, pageBackButtonHelp as AnyHelpFile)
mergeHelp(registry, pageLayoutHelp as AnyHelpFile)
mergeHelp(registry, pageSpinnerHelp as AnyHelpFile)
mergeHelp(registry, paginationHelp as AnyHelpFile)
mergeHelp(registry, parameterEditorHelp as AnyHelpFile)
mergeHelp(registry, parameterFormHelp as AnyHelpFile)
mergeHelp(registry, partiesHelp as AnyHelpFile)
mergeHelp(registry, partyDetailHelp as AnyHelpFile)
mergeHelp(registry, patternSuggestDialogHelp as AnyHelpFile)
mergeHelp(registry, peerRecommendationListHelp as AnyHelpFile)
mergeHelp(registry, previewPaneHelp as AnyHelpFile)
mergeHelp(registry, previewResultDialogHelp as AnyHelpFile)
mergeHelp(registry, profileHelp as AnyHelpFile)
mergeHelp(registry, progressBarHelp as AnyHelpFile)
mergeHelp(registry, propertyPanelHelp as AnyHelpFile)
mergeHelp(registry, provisioningHelp as AnyHelpFile)
mergeHelp(registry, provisioningDashboardHelp as AnyHelpFile)
mergeHelp(registry, provisioningHistoryHelp as AnyHelpFile)
mergeHelp(registry, provisioningTaskDetailHelp as AnyHelpFile)
mergeHelp(registry, provisioningTasksHelp as AnyHelpFile)
mergeHelp(registry, provisioningTasksSubPageHelp as AnyHelpFile)
mergeHelp(registry, recentNotificationsHelp as AnyHelpFile)
mergeHelp(registry, registryHelpIconPortalHelp as AnyHelpFile)
mergeHelp(registry, rehireReviewHelp as AnyHelpFile)
mergeHelp(registry, rehireReviewDetailHelp as AnyHelpFile)
mergeHelp(registry, relationshipSchemaHelp as AnyHelpFile)
mergeHelp(registry, removeRoleDialogHelp as AnyHelpFile)
mergeHelp(registry, reportCategoriesPageHelp as AnyHelpFile)
mergeHelp(registry, reportDefinitionDetailHelp as AnyHelpFile)
mergeHelp(registry, reportDefinitionEditHelp as AnyHelpFile)
mergeHelp(registry, requestDetailHelp as AnyHelpFile)
mergeHelp(registry, requestInspectorHelp as AnyHelpFile)
mergeHelp(registry, requestInspectorDetailHelp as AnyHelpFile)
mergeHelp(registry, resourceDetailHelp as AnyHelpFile)
mergeHelp(registry, resourcesHelp as AnyHelpFile)
mergeHelp(registry, responseFiltersEditorHelp as AnyHelpFile)
mergeHelp(registry, restConfigCardHelp as AnyHelpFile)
mergeHelp(registry, restConfigEditDialogHelp as AnyHelpFile)
mergeHelp(registry, restrictionRuleDetailHelp as AnyHelpFile)
mergeHelp(registry, restrictionRuleDetectionsHelp as AnyHelpFile)
mergeHelp(registry, restrictionRuleRequestCreateWizardHelp as AnyHelpFile)
mergeHelp(registry, restrictionRuleRequestDetailHelp as AnyHelpFile)
mergeHelp(registry, restrictionRuleRequestEditHelp as AnyHelpFile)
mergeHelp(registry, restrictionRuleRequestsHelp as AnyHelpFile)
mergeHelp(registry, restrictionRuleViolationsHelp as AnyHelpFile)
mergeHelp(registry, restrictionRuleViolationsDashboardHelp as AnyHelpFile)
mergeHelp(registry, restrictionRulesHelp as AnyHelpFile)
mergeHelp(registry, resultTableHelp as AnyHelpFile)
mergeHelp(registry, reviewInfoCardHelp as AnyHelpFile)
mergeHelp(registry, reviewStepHelp as AnyHelpFile)
mergeHelp(registry, revokeApiKeyDialogHelp as AnyHelpFile)
mergeHelp(registry, roleAssignmentsHelp as AnyHelpFile)
mergeHelp(registry, roleDetailHelp as AnyHelpFile)
mergeHelp(registry, rolesHelp as AnyHelpFile)
mergeHelp(registry, sapAbapConfigCardHelp as AnyHelpFile)
mergeHelp(registry, sapAbapOutboundConfigCardHelp as AnyHelpFile)
mergeHelp(registry, sapAbapOutboundConfigEditDialogHelp as AnyHelpFile)
mergeHelp(registry, sapHcmInboundConfigCardHelp as AnyHelpFile)
mergeHelp(registry, sapHcmInboundConfigEditDialogHelp as AnyHelpFile)
mergeHelp(registry, sapSfEcInboundConfigCardHelp as AnyHelpFile)
mergeHelp(registry, sapSfEcInboundConfigEditDialogHelp as AnyHelpFile)
mergeHelp(registry, schemaHelp as AnyHelpFile)
mergeHelp(registry, schemaPoliciesHelp as AnyHelpFile)
mergeHelp(registry, schemaPolicyEditHelp as AnyHelpFile)
mergeHelp(registry, schemaViolationsHelp as AnyHelpFile)
mergeHelp(registry, scimConfigCardHelp as AnyHelpFile)
mergeHelp(registry, scopePreviewPanelHelp as AnyHelpFile)
mergeHelp(registry, scriptConfigCardHelp as AnyHelpFile)
mergeHelp(registry, scriptEditorCoreHelp as AnyHelpFile)
mergeHelp(registry, scriptEditorPageHelp as AnyHelpFile)
mergeHelp(registry, scriptExecuteLogPageHelp as AnyHelpFile)
mergeHelp(registry, scriptInboundConfigCardHelp as AnyHelpFile)
mergeHelp(registry, scriptSqlDialogHelp as AnyHelpFile)
mergeHelp(registry, sectionCardHelp as AnyHelpFile)
mergeHelp(registry, sectionPageHeaderHelp as AnyHelpFile)
mergeHelp(registry, sectionPropertiesHelp as AnyHelpFile)
mergeHelp(registry, serverUnavailableOverlayHelp as AnyHelpFile)
mergeHelp(registry, serviceAccountDetailHelp as AnyHelpFile)
mergeHelp(registry, serviceAccountsHelp as AnyHelpFile)
mergeHelp(registry, severityBadgeHelp as AnyHelpFile)
mergeHelp(registry, sidebarNavHelp as AnyHelpFile)
mergeHelp(registry, skipToContentLinkHelp as AnyHelpFile)
mergeHelp(registry, sourcesCardHelp as AnyHelpFile)
mergeHelp(registry, spanDetailSheetHelp as AnyHelpFile)
mergeHelp(registry, spanWaterfallHelp as AnyHelpFile)
mergeHelp(registry, sqlAssistPanelHelp as AnyHelpFile)
mergeHelp(registry, sqlEditorHelp as AnyHelpFile)
mergeHelp(registry, sqlEditorDialogHelp as AnyHelpFile)
mergeHelp(registry, syncRunsTabHelp as AnyHelpFile)
mergeHelp(registry, systemDetailHelp as AnyHelpFile)
mergeHelp(registry, systemGrantsDetailHelp as AnyHelpFile)
mergeHelp(registry, systemsHelp as AnyHelpFile)
mergeHelp(registry, tableEmptyStateHelp as AnyHelpFile)
mergeHelp(registry, tagInputHelp as AnyHelpFile)
mergeHelp(registry, targetSystemsResourcesHelp as AnyHelpFile)
mergeHelp(registry, testDataGeneratorHelp as AnyHelpFile)
mergeHelp(registry, testResultsPanelHelp as AnyHelpFile)
mergeHelp(registry, themeToggleHelp as AnyHelpFile)
mergeHelp(registry, timeSwitchHelp as AnyHelpFile)
mergeHelp(registry, toasterHelp as AnyHelpFile)
mergeHelp(registry, triggerFullEvaluationButtonHelp as AnyHelpFile)
mergeHelp(registry, typeDetailHelp as AnyHelpFile)
mergeHelp(registry, typeScopeFilterHelp as AnyHelpFile)
mergeHelp(registry, typeScopeSelectorHelp as AnyHelpFile)
mergeHelp(registry, typeValueDetailHelp as AnyHelpFile)
mergeHelp(registry, typeValuesViewHelp as AnyHelpFile)
mergeHelp(registry, typesHelp as AnyHelpFile)
mergeHelp(registry, unifiedSearchBarHelp as AnyHelpFile)
mergeHelp(registry, unifiedSearchBarDemoHelp as AnyHelpFile)
mergeHelp(registry, valueListDetailHelp as AnyHelpFile)
mergeHelp(registry, valueListsHelp as AnyHelpFile)
mergeHelp(registry, versionHistoryCardHelp as AnyHelpFile)
mergeHelp(registry, wizardStepBasicsHelp as AnyHelpFile)
mergeHelp(registry, wizardStepLaunchHelp as AnyHelpFile)
mergeHelp(registry, wizardStepReviewSettingsHelp as AnyHelpFile)
mergeHelp(registry, wizardStepScopeHelp as AnyHelpFile)
mergeHelp(registry, workflowTimelineCardHelp as AnyHelpFile)

prefixEntries.sort((a, b) => b[0].length - a[0].length)

export const helpRegistry: Readonly<Record<string, HelpRegistryEntry>> = registry

export function getEntryForTestid(testid: string): HelpRegistryEntry | undefined {
  const exact = registry[testid]
  if (exact) return exact
  for (const [prefix, entry] of prefixEntries) {
    if (testid.startsWith(prefix)) return entry
  }
  return undefined
}

export function getDocPage(entry: HelpRegistryEntry): string | undefined {
  const url = docPages[entry.fileIndex]
  return url ? url : undefined
}

// CPD-ON
